import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M5.77478 20.5C5.32584 20.5 4.87691 20.3207 4.51775 19.962C4.06881 19.5136 3.88924 18.8859 4.06881 18.3478L4.96669 14.3125C5.05648 13.7745 5.32584 13.3261 5.685 12.9674L13.5863 5.07609C15.0229 3.6413 17.2676 3.6413 18.7042 5.07609L19.4225 5.79348C20.1408 6.51087 20.5 7.40761 20.5 8.30435C20.5 9.20109 20.1408 10.1875 19.4225 10.9049L11.5212 18.7962C11.1621 19.1549 10.7131 19.4239 10.1744 19.5136L6.13394 20.4103C6.04415 20.5 5.86457 20.5 5.77478 20.5ZM16.1004 5.79348C15.6515 5.79348 15.2025 5.97283 14.8434 6.33152L6.94203 14.2228C6.76245 14.3125 6.67266 14.4918 6.67266 14.6712L5.77478 18.5272C5.77478 18.6168 5.77478 18.6168 5.86457 18.6168L9.72545 17.7201C9.90503 17.7201 10.0846 17.6304 10.1744 17.4511L18.0757 9.55978C18.4349 9.20109 18.6145 8.75272 18.6145 8.30435C18.6145 7.85598 18.4349 7.40761 18.0757 7.04891L17.2676 6.24185C16.9983 5.97283 16.5493 5.79348 16.1004 5.79348Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M16.7722 12.2591L12.1284 7.71049L13.2487 6.56674L17.8925 11.1154L16.7722 12.2591Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgEdit);
export default ForwardRef;
